import { BaseApi } from "api/BaseApi.ts";
import tenantAxiosInstance, { PaldockTenantAxiosInstance } from "api/tenantAxiosInstance.ts";

export class TenantBaseApi extends BaseApi {
    protected getAxiosInstance(): PaldockTenantAxiosInstance {
        return tenantAxiosInstance;
    }
}
